<div class='content flex-column justify-center align-center'>
  <div class='profile-form flex-column'>
    <h3 class='section-label'>{{ 'complete-profile.sensorLabel' | translate }}</h3>
    <div class='toggle-grid three-col'>
      @for (sensor of sensorOptions; track sensor.key) {
        <button mat-button
                class='toggle-btn'
                data-testid='sensor-btn-{{sensor.key}}'
                [class.secondary-action]='!isSensorSelected(sensor.key)'
                [class.primary-action]='isSensorSelected(sensor.key)'
                (click)='toggleSensor(sensor.key)'>
          {{ sensor.label | translate }}
          @if (isSensorSelected(sensor.key)) {
            <mat-icon class='check-icon lt-md:hide'
                      svgIcon='check_circle'></mat-icon>
          }
        </button>
      }
    </div>

    @if (premiumContentImages().length > 0) {
      <h3 class='section-label'>{{ 'complete-profile.premiumContentLabel' | translate }}</h3>
      <div class='premium-content-grid'>
        @for (img of premiumContentImages(); track img.src) {
          <img class='premium'
               [src]='img.src'
               [alt]='img.alt'>
        }
      </div>
      <p class='section-hint'>{{ 'complete-profile.premiumContentHint' | translate }}</p>
    }
  </div>
</div>
